import { render } from "./LegendDomains.vue?vue&type=template&id=7069ad7b&scoped=true"
import script from "./LegendDomains.vue?vue&type=script&lang=js"
export * from "./LegendDomains.vue?vue&type=script&lang=js"

import "./LegendDomains.vue?vue&type=style&index=0&id=7069ad7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7069ad7b"]])

export default __exports__